import { Web3Provider } from '@ethersproject/providers';
import { pollingInterval } from '../configs';



export default function getLibrary(provider: any): Web3Provider {
  const library = new Web3Provider(provider);
  library.pollingInterval = pollingInterval;
  return library;
}
